// extracted by mini-css-extract-plugin
export default {"rightBox":"styles_rightBox__5vN0O","content":"styles_content__hGdaN","imageBox":"styles_imageBox__n7AJk"};